<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-money-bill-wave"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="dialogForm" :labelColumnSize="2" v-if="!loading">
      <FormRow label="Name">
        <FormInputText placeholder="Name" v-model="surchargeConfig.name" field="name" />
      </FormRow>

      <FormRow label="Active">
        <FormCheckbox v-model="surchargeConfig.isActive" field="isActive" />
      </FormRow>

      <FormRow label="Stock" helpTip="The stock used to add to orders when this surcharge is applied">
        <FormInputStockCode :stockType="InventoryStockTypes.general" v-model="surchargeConfig.stockId" />
      </FormRow>

      <FormRow label="Unit Price Override" helpTip="If set, overrides the default stock price with this value for the unit price of the surcharge" >
        <FormCheckbox v-model="surchargeConfig.isPriceOverridden" field="isPriceOverridden" />
      </FormRow>

      <FormRow label="Override Amount" v-show="surchargeConfig.isPriceOverridden">
        <FormInputStockPrice v-model="surchargeConfig.unitPriceOverride" field="unitPriceOverride" :uomType="uomType" />
      </FormRow>

      <FormUpdateFilter label="Customer Filter" :options="customerLookup" v-model="surchargeConfig.contactFilter" field="contactFilter" :editing="true" />

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import FormInputStockCode from '@/modules/inventory/components/formInputStockCode'
import FormInputStockPrice from '@/modules/pricing/components/formInputStockPrice'

import { InventoryStockTypes } from '@/store/types'

export default {
  name: 'OrderSurchargeConfigDialog',
  mixins: [
    ModalDialogMixin,
    form,
  ],
  components: {
    ModalDialog,
    FormInputStockCode,
    FormInputStockPrice
  },
  props: {
    isCreateMode: Boolean
  },
  watch: {
  },
  data() {
    return {
      dialogForm: {},
      submitting: false,
      loading: false,
      loadingError: '',
      surchargeConfig: {
        id: null,
        isActive: true,
        name: '',
        isPriceOverridden: false,
        unitPriceOverride: 0,
        contactFilter: {},
        stockId: null        
      },
      stockList: [],
      customerLookup: []
    }
  },
  mounted() {
  },
  created() {
    this.InventoryStockTypes = InventoryStockTypes
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Order Surcharge' : 'Edit Order Surcharge'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
    uomType() {
      var stockItem = this.stockList.find(item => item.id == this.surchargeConfig.stockId)
      if(stockItem) {
        return stockItem.uomType
      }
      return null
    }
  },
  methods: {
    show(orderSurcharge) {      
      this.dialogForm = this.clearFormResponse()
      this.submitting = false

      if(orderSurcharge) {
        this.surchargeConfig = _.cloneDeep(orderSurcharge)
      }

      this.requestData()      

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.dialogForm = this.clearFormResponse()
      this.submitting = true

      var updateData = {
        name: this.surchargeConfig.name,
        isActive: this.surchargeConfig.isActive,
        isPriceOverridden: this.surchargeConfig.isPriceOverridden,
        unitPriceOverride: this.surchargeConfig.unitPriceOverride,
        contactFilter: this.surchargeConfig.contactFilter,
        stockId: this.surchargeConfig.stockId
      }

      if(this.isCreateMode) {
        this.$apiService.ordersService.createOrderSurcharge(updateData)
        .then(() => {
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.dialogForm = this.processFormResponse(err)
        })
        .finally(() => {
          this.submitting = false
        })
      }
      else {
        this.$apiService.ordersService.updateOrderSurcharge(this.surchargeConfig.id, updateData)
        .then(() => {
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.dialogForm = this.processFormResponse(err)
         })
        .finally(() => {
          this.submitting = false
        })
      }
    },
    requestData() {
      this.loading = false
      this.loadingError = ''

      Promise.all([
        this.$apiService.contactService.getContactList({ isActive: 1 }),
        this.$apiService.inventoryService.getStockList()
      ])
      .then(results => {
        this.customerLookup = results[0].data.map(item => {
          return { value: item.id, name: item.name }
        })
        this.stockList = results[1].data.filter(item => item.isActive)

        //this.stampConfig = results[3].data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>